<svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  viewBox="0 0 24 24"
  stroke-width="2"
  stroke="currentColor"
  stroke-linecap="round"
  stroke-linejoin="round"
  class="h-6 w-6"
>
  <path d="M19 17V5a2 2 0 0 0-2-2H4" />
  <path
    d="M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3"
  />
</svg>
